import script from "./registration-form.vue?vue&type=script&setup=true&lang=js"
export * from "./registration-form.vue?vue&type=script&setup=true&lang=js"

import "./registration-form.vue?vue&type=style&index=0&id=4397afc2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4397afc2"]])

export default __exports__